
import { listOrganizations, deleteOrganization as deleteOrgAPI, organizationStatusChange as orgStatusChangeAPI } from '../services/organization_service';

const useOrganizations = (organizationId = null) => {
    const [organizationsData, setOrganizationsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchOrganizationsData = async () => {
            try {
                const organizations = await listOrganizations(organizationId);
                // organizations.forEach((organization, index) => {
                //     organization.serial = index + 1;
                // });

                // if (organizations.users) {
                //     organizations.users.forEach((user, index) => {
                //         user.serial = index + 1;
                //     });
                // }

                // if (organizations.documents) {
                //     organizations.documents.forEach((document, index) => {
                //         document.serial = index + 1;
                //     });
                // }

                setOrganizationsData(organizations);
                setIsLoading(false);
            } catch (error) {
                setError(error.message);
                setIsLoading(false);
            }
        };

        fetchOrganizationsData();
    }, [organizationId]);

    const deleteOrganization = async (id) => {
        try {
            await deleteOrgAPI(id);
            setOrganizationsData(organizationsData.filter(item => item.id !== id));
        } catch (error) {
            setError(error.message);
        }
    };

    const organizationStatusChange = async (id, action) => {
        try {
            const res = await orgStatusChangeAPI(id, action);
            return res;
        } catch (error) {
            setError(error.message);
        }
    };

    return { organizationsData, isLoading, error, deleteOrganization, organizationStatusChange, setOrganizationsData };
};

export default useOrganizations;
